import { Swiper, SwiperSlide } from "swiper/react";
// import Swiper core and required modules
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper";
import { useState } from "react";
import "swiper/swiper.scss";
import "./CarouselAds.scss";
import styled from 'styled-components'

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

export const CarouselAds = ({ items, type }) => {
  const [controller, setController] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [currentIndex, setCurrentIndex] = useState(0);

  const onNext = () => {
    controller.slideNext();
  };

  const onPrevious = () => {
    controller.slidePrev();
  };

  if (!items) {
    return null;
  }

  const onErrorException = (e) => {
    e.target.src =
      "https://dummyimage.com/286x175/e8e8e8/9e9e9e&text=Image+Error";
  };

  return (
    <div className="carousel-ads">
      <Swiper
        slidesPerView={3}
        centeredSlides={true}
        spaceBetween= {24}
        breakpoints={{
            "@0.00": {
              centeredSlides:"false",
              slidesPerView: 3,
              spaceBetween: 16,
            },
            "@0.75": {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            "@1.00": {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            "@1.50": {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }}
        loop={true}
        scrollbar={{
          draggable: true,
        }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        onSwiper={(swiper) => setController(swiper)}
        onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
      >
        {
          type === "linking" ? (
            items.map((data, i) => (
              <SwiperSlide key={`carousel-ads-${i}`} className="card-slide">
                 <a href={`/promotion/detail/${data.link}`}>
                 <Desktop>
                  <img src={data.ImageDesktop} onError={onErrorException} alt="..." />
                 </Desktop>
                 <Mobile>
                  <img src={data.ImageMobile} onError={onErrorException} alt="..." />
                 </Mobile>
                  <div className="body">
                    <h4>{data.shortdescription}</h4>
                    <div dangerouslySetInnerHTML={{ __html: data.fullDescription }}></div>
                  </div>
                 </a>
              </SwiperSlide>
            ))
          ) : (
            items.map((data, i) => (
              <SwiperSlide key={`carousel-ads-${i}`} className="card-slide">
                  <img src={data.image} onError={onErrorException} alt="..." />
                  <div className="body">
                    <h4>{data.title}</h4>
                    <p>{data.description}</p>
                  </div>
              </SwiperSlide>
            ))
          )        
      }
        {/* {items.map((data, i) => (
          <SwiperSlide key={`carousel-ads-${i}`} className="card-slide">
              <img src={data.image} onError={onErrorException} alt="..." />
              <div className="body">
                <h4>{data.title} huhu</h4>
                <p>{data.description} haha</p>
              </div>
          </SwiperSlide>
        ))} */}
      </Swiper>
      <div className="carousel-ads-footer">
        <button onClick={() => onPrevious()}>
          <i className="bi bi-chevron-left"></i>
        </button>
        <button onClick={() => onNext()}>
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};

export default CarouselAds;
